import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton } from '@bingads-webui-react/fabric-control';
import { noop, mapObject, constant } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getIMAReachModalStyles } from './styles';

class IMAReachModal extends React.PureComponent {
  renderModalContent = () => (
    <div className="ima-reach-modal-content">
      <div className="ima-reach-pre-description">
        {this.props.i18n.getString('IMA_Reach_Representation_Modal_PreDescription')}
      </div>
      <br />
      <div className="ima-reach-audience-list">
        {this.props.ineligibleAudiences.map(audience => (
          <div key={audience}>
            <b className="ima-reach-audience-list-item">
              {`- ${audience}`}
            </b>
          </div>
        ))}
      </div>
      <br />
      <div className="ima-reach-after-description">
        {this.props.i18n.getString('IMA_Reach_Representation_Modal_AfterDescription')}
      </div>
    </div>);

  render() {
    const {
      classes,
      onYes,
      onCancel,
      i18n,
      hideDialog,
    } = this.props;

    return (
      <Dialog
        hidden={hideDialog}
        onDismiss={onCancel}
        dialogContentProps={{
          type: DialogType.close,
          title: this.props.i18n.getString('IMA_Reach_Representation_Modal_Title'),
        }}
        maxWidth={560}
        minWidth={288}
        modalProps={{
          isBlocking: true,
          className: classNames(classes.imaReachModal, 'ima-reach-modal'),
        }}
        {...this.props}
      >
        { this.renderModalContent()}
        <DialogFooter styles={{
            actionsRight: {
              textAlign: 'left',
            },
          }}
        >
          <PrimaryButton className="yes-btn" onClick={onYes} aria-label={i18n.getString('Yes')}>
            {i18n.getString('Yes')}
          </PrimaryButton>
          <DefaultButton className="cancel-btn" onClick={onCancel} aria-label={i18n.getString('Cancel')}>
            {i18n.getString('Cancel')}
          </DefaultButton>
        </DialogFooter>
      </Dialog>);
  }
}

IMAReachModal.propTypes = {
  classes: PropTypes.shape(mapObject(
    getIMAReachModalStyles({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  hideDialog: PropTypes.bool.isRequired,
  ineligibleAudiences: PropTypes.arrayOf(PropTypes.string).isRequired,
  onYes: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

IMAReachModal.defaultProps = {
  onCancel: noop,
};

export const StyledIMAReachModal =
  withDefaultStyles(IMAReachModal, getIMAReachModalStyles);
